module.exports = __webpack_public_path__ + "static/logo-9326fae76e734c46403554cd9876768e.svg";